export default __webpack_public_path__ + "static/media/02.3e2d1a8c.jpg";